// Copies of the gazetteer's own name and postcode normalisation (shared/gazetteer/src/index.ts). A name is found by hashing
// its normalised form to a shard, so these must match the builder exactly; shared/gazetteer/__tests__/uiCopy.test.ts checks it.

const NAME_SHARD_COUNT = 256;

const ABBREVIATIONS: Record<string, string> = {
  rd: 'road',
  ln: 'lane',
  ave: 'avenue',
  av: 'avenue',
  dr: 'drive',
  cl: 'close',
  ct: 'court',
  cres: 'crescent',
  gdns: 'gardens',
  pl: 'place',
  sq: 'square',
  grn: 'green',
  pk: 'park',
  hts: 'heights',
  ter: 'terrace',
  wy: 'way',
  mt: 'mount',
  nth: 'north',
  sth: 'south',
};

export function normaliseName(raw: string): string {
  const tokens = raw
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/['’`]/g, '')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .split(' ')
    .filter(Boolean);
  return tokens
    .map((t, i) => {
      if (t === 'st') return i === tokens.length - 1 ? 'street' : 'saint';
      return ABBREVIATIONS[t] ?? t;
    })
    .join(' ');
}

function fnv1a32(s: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return h >>> 0;
}

/** Two-hex-digit shard id for an already-normalised name. */
export function shardForName(normalisedName: string): string {
  return (fnv1a32(normalisedName) % NAME_SHARD_COUNT).toString(16).padStart(2, '0');
}

const POSTCODE_RE = /^([A-Z]{1,2}[0-9][A-Z0-9]?)\s*([0-9][A-Z]{2})$/;

/** "bs32  4jz" or "BS324JZ" to "BS32 4JZ"; null when it is not a full UK postcode. */
export function normalisePostcode(raw: string): string | null {
  const m = POSTCODE_RE.exec(raw.trim().toUpperCase());
  return m ? `${m[1]} ${m[2]}` : null;
}
